import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrash, faPlus, faEdit, faEye } from '@fortawesome/free-solid-svg-icons';
import BaseURL from '../assets/contants/BaseURL';
import Header from '../components/header';
import { useNavigate } from 'react-router-dom';

const LevelMeter = () => {
    const [levelMeters, setLevelMeters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedMeters, setSelectedMeters] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [currentMeter, setCurrentMeter] = useState({
        level_meter_name: '',
        level_meter_id: '',
        serial_number: '',
        model: '',
        location: '',
        installation_date: '',
        status: 1
    });

    const navigate = useNavigate();
    const itemsPerPage = 10;

    const fetchLevelMeters = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${BaseURL}meters/waterlevelmeter/`);
            setLevelMeters(response.data);
            setTotalPages(Math.ceil(response.data.length / itemsPerPage));
            setLoading(false);
        } catch (error) {
            console.error('Error fetching level meters:', error);
            setErrorMessage('Failed to fetch level meters');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLevelMeters();
    }, []);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const filteredMeters = levelMeters.filter(meter =>
        Object.values(meter).some(
            value => value && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        ));

    const paginatedMeters = filteredMeters.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);
        if (isChecked) {
            setSelectedMeters(paginatedMeters.map(meter => meter.id));
        } else {
            setSelectedMeters([]);
        }
    };

    const handleCheckboxChange = (id) => {
        if (selectedMeters.includes(id)) {
            setSelectedMeters(selectedMeters.filter(meterId => meterId !== id));
        } else {
            setSelectedMeters([...selectedMeters, id]);
        }
    };

    const handleAddMeter = async () => {
        try {
            const response = await axios.post(`${BaseURL}meters/waterlevelmeter/`, currentMeter);
            setLevelMeters([...levelMeters, response.data]);
            setShowAddModal(false);
            setSuccessMessage('Level meter added successfully!');
            setTimeout(() => setSuccessMessage(''), 3000);
            resetForm();
        } catch (error) {
            console.error('Error adding level meter:', error);
            setErrorMessage('Failed to add level meter');
        }
    };

    const handleEditMeter = async () => {
        try {
            const response = await axios.put(
                `${BaseURL}meters/waterlevelmeter/${currentMeter.id}/`,
                currentMeter
            );
            setLevelMeters(levelMeters.map(meter =>
                meter.id === currentMeter.id ? response.data : meter
            ));
            setShowEditModal(false);
            setSuccessMessage('Level meter updated successfully!');
            setTimeout(() => setSuccessMessage(''), 3000);
            resetForm();
        } catch (error) {
            console.error('Error updating level meter:', error);
            setErrorMessage('Failed to update level meter');
        }
    };

    const handleDeleteMeter = async () => {
        try {
            if (selectedMeters.length > 0) {
                await Promise.all(selectedMeters.map(id =>
                    axios.delete(`${BaseURL}meters/waterlevelmeter/${id}/`)
                ));
                setLevelMeters(levelMeters.filter(meter => !selectedMeters.includes(meter.id)));
                setSelectedMeters([]);
                setSelectAll(false);
                setShowDeleteModal(false);
                setSuccessMessage('Selected level meters deleted successfully!');
            }
            else if (currentMeter.id) {
                await axios.delete(`${BaseURL}meters/waterlevelmeter/${currentMeter.id}/`);
                setLevelMeters(levelMeters.filter(meter => meter.id !== currentMeter.id));
                setShowDeleteModal(false);
                setSuccessMessage('Level meter deleted successfully!');
            }
            setTimeout(() => setSuccessMessage(''), 3000);
        } catch (error) {
            console.error('Error deleting level meter:', error);
            setErrorMessage('Failed to delete level meter');
        }
    };

    const resetForm = () => {
        setCurrentMeter({
            level_meter_name: '',
            level_meter_id: '',
            serial_number: '',
            model: '',
            location: '',
            installation_date: '',
            status: 1
        });
    };

    const openEditModal = (meter) => {
        setCurrentMeter(meter);
        setShowEditModal(true);
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCurrentMeter({
            ...currentMeter,
            [name]: value
        });
    };

    const openViewModal = () => {
        navigate("/EMS/flowportal");
    };

    return (
        <div style={{ textAlign: 'center', width: '100%' }}>
            <div style={{
                backgroundColor: '#007acc',
                color: 'white',
                alignContent: 'center',
                fontSize: '14px',
                height: '40px'
            }}>
                <Header title="LEVEL METER LIST" />
            </div>

            <div style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginTop: '20px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                backgroundColor: 'white',
                margin: '20px auto',
                maxWidth: '1000px',
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '30%' }}>
                        <input
                            type="text"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={handleSearch}
                            style={{
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                flex: '1',
                                marginRight: '10px',
                            }}
                        />
                        <FontAwesomeIcon
                            icon={faSearch}
                            style={{ color: '#007acc', cursor: 'pointer' }}
                        />
                    </div>

                    <div style={{ marginLeft: "auto" }}>
                        <button
                            onClick={() => setShowDeleteModal(true)}
                            style={{
                                padding: "10px 15px",
                                marginRight: "10px",
                                backgroundColor: "#f44336",
                                color: "white",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} style={{ marginRight: "5px" }} />
                            Delete
                        </button>

                        <button
                            onClick={() => setShowAddModal(true)}
                            style={{
                                padding: '10px 15px',
                                backgroundColor: '#4CAF50',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                marginRight: '10px',
                            }}
                        >
                            <FontAwesomeIcon icon={faPlus} style={{ marginRight: '5px' }} />
                            Add
                        </button>
                    </div>
                </div>
            </div>

            <div style={{ textAlign: 'center', margin: '20px 0' }}>
                {successMessage && (
                    <div style={{
                        padding: '10px',
                        borderRadius: '5px',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        margin: '10px auto',
                        width: 'fit-content',
                    }}>
                        {successMessage}
                    </div>
                )}
                {errorMessage && (
                    <div style={{
                        padding: '10px',
                        borderRadius: '5px',
                        backgroundColor: '#f44336',
                        color: 'white',
                        margin: '10px auto',
                        width: 'fit-content',
                    }}>
                        {errorMessage}
                    </div>
                )}
            </div>

            <div style={{
                marginTop: '20px',
                padding: '10px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                backgroundColor: 'white',
                maxWidth: '1000px',
                margin: '20px auto',
                marginBottom: '70px',
            }}>
                {loading ? (
                    <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
                ) : (
                    <>
                        <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
                            <thead style={{ backgroundColor: '#007acc', color: 'white' }}>
                                <tr>
                                    <th style={{ padding: '5px' }}>
                                        <input
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    <th style={{ padding: '10px' }}>S.No</th>
                                    <th style={{ padding: '10px' }}>Level Meter Name</th>
                                    <th style={{ padding: '10px' }}>Level Meter ID</th>
                                    <th style={{ padding: '10px' }}>Model</th>
                                    <th style={{ padding: '10px' }}>Location</th>
                                    <th style={{ padding: '10px' }}>Installation Date</th>
                                    <th style={{ padding: '10px' }}>Status</th>
                                    <th style={{ padding: '10px' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedMeters.length > 0 ? (
                                    paginatedMeters.map((meter, index) => (
                                        <tr
                                            key={meter.id}
                                            style={{
                                                backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#ffffff',
                                            }}
                                        >
                                            <td style={{ padding: '10px' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedMeters.includes(meter.id)}
                                                    onChange={() => handleCheckboxChange(meter.id)}
                                                />
                                            </td>
                                            <td style={{ padding: '15px' }}>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                            <td style={{ padding: '15px' }}>{meter.level_meter_name}</td>
                                            <td style={{ padding: '15px' }}>{meter.level_meter_id}</td>
                                            <td style={{ padding: '15px' }}>{meter.model}</td>
                                            <td style={{ padding: '15px' }}>{meter.location}</td>
                                            <td style={{ padding: '15px' }}>{meter.installation_date}</td>
                                            <td style={{ padding: '15px' }}>
                                                {meter.status === 1 ? 'Active' : 'Inactive'}
                                            </td>
                                            <td style={{ padding: "15px", display: 'flex', gap: '10px' }}>
                                                <span
                                                    style={{ color: "blue", cursor: "pointer" }}
                                                    onClick={() => openEditModal(meter)}
                                                >
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </span>
                                                <span
                                                    style={{ color: "green", cursor: "pointer" }}
                                                    onClick={() => openViewModal()}
                                                >
                                                    <FontAwesomeIcon icon={faEye} />
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" style={{ padding: '10px', textAlign: 'center' }}>
                                            No results found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                style={{
                                    margin: '0 5px',
                                    padding: '5px 10px',
                                    background: currentPage === 1 ? '#007acc' : '#007acc',
                                    color: currentPage === 1 ? '#9e9e9e' : '#ffffff',
                                    border: 'none',
                                    borderRadius: '25px',
                                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                    boxShadow: currentPage === 1 ? 'none' : '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                    fontSize: '12px',
                                }}
                            >
                                Previous
                            </button>

                            {currentPage > 3 && (
                                <>
                                    <button
                                        onClick={() => handlePageChange(1)}
                                        style={{
                                            margin: '0 5px',
                                            padding: '5px 10px',
                                            background: '#f7f7f7',
                                            color: '#333333',
                                            border: '1px solid #ddd',
                                            borderRadius: '25px',
                                            cursor: 'pointer',
                                            fontSize: '12px',
                                        }}
                                    >
                                        1
                                    </button>
                                    <span style={{ margin: '0 5px', fontSize: '14px' }}>...</span>
                                </>
                            )}
                            {Array.from({ length: 5 }, (_, i) => {
                                const pageNumber = currentPage - 2 + i;
                                if (pageNumber > 0 && pageNumber <= totalPages) {
                                    return (
                                        <button
                                            key={pageNumber}
                                            onClick={() => handlePageChange(pageNumber)}
                                            style={{
                                                margin: '0 5px',
                                                padding: '5px 10px',
                                                background: currentPage === pageNumber ? '#007acc' : 'linear-gradient(to right, #f7f7f7, #e0e0e0)',
                                                color: currentPage === pageNumber ? '#ffffff' : '#333333',
                                                border: '1px solid #ddd',
                                                borderRadius: '25px',
                                                cursor: 'pointer',
                                                fontSize: '12px',
                                            }}
                                        >
                                            {pageNumber}
                                        </button>
                                    );
                                }
                                return null;
                            })}
                            {currentPage < totalPages - 2 && (
                                <>
                                    <span style={{ margin: '0 5px', fontSize: '14px' }}>...</span>
                                    <button
                                        onClick={() => handlePageChange(totalPages)}
                                        style={{
                                            margin: '0 5px',
                                            padding: '5px 10px',
                                            background: '#f7f7f7',
                                            color: '#333333',
                                            border: '1px solid #ddd',
                                            borderRadius: '25px',
                                            cursor: 'pointer',
                                            fontSize: '12px',
                                        }}
                                    >
                                        {totalPages}
                                    </button>
                                </>
                            )}
                            <button
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                style={{
                                    margin: '0 5px',
                                    padding: '5px 10px',
                                    background: currentPage === totalPages ? '#007acc' : '#007acc',
                                    color: currentPage === totalPages ? '#9e9e9e' : '#ffffff',
                                    border: 'none',
                                    borderRadius: '25px',
                                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                    boxShadow: currentPage === totalPages ? 'none' : '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                    fontSize: '12px',
                                }}
                            >
                                Next
                            </button>
                        </div>
                    </>
                )}
            </div>

            {showAddModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '30px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                        width: '60%',
                        maxWidth: '900px',
                        maxHeight: '70vh',
                        overflowY: 'auto',
                    }}>
                        <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>
                            Add New Level Meter
                        </h4>

                        <div style={{
                            display: 'flex',
                            gap: '30px',
                            marginBottom: '20px'
                        }}>
                            <div style={{
                                flex: '1',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '20px'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Level Meter Name
                                    </label>
                                    <input
                                        type="text"
                                        name="level_meter_name"
                                        value={currentMeter.level_meter_name}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '95%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Level Meter ID
                                    </label>
                                    <input
                                        type="text"
                                        name="level_meter_id"
                                        value={currentMeter.level_meter_id}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '95%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Serial Number
                                    </label>
                                    <input
                                        type="text"
                                        name="serial_number"
                                        value={currentMeter.serial_number}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '95%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>
                            </div>

                            <div style={{
                                flex: '1',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '20px'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Model
                                    </label>
                                    <input
                                        type="text"
                                        name="model"
                                        value={currentMeter.model}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '95%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Location
                                    </label>
                                    <input
                                        type="text"
                                        name="location"
                                        value={currentMeter.location}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '95%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Installation Date
                                    </label>
                                    <input
                                        type="date"
                                        name="installation_date"
                                        value={currentMeter.installation_date}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '95%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', width: '40%', marginLeft: '270px' }}>
                            <button
                                onClick={handleAddMeter}
                                style={{
                                    backgroundColor: '#4CAF50',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 15px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    flex: '1',
                                    marginRight: '10px',
                                }}
                            >
                                Save
                            </button>
                            <button
                                onClick={() => {
                                    setShowAddModal(false);
                                    resetForm();
                                }}
                                style={{
                                    backgroundColor: '#f44336',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 15px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    flex: '1',
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showEditModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '30px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                        width: '60%',
                        maxWidth: '900px',
                        maxHeight: '70vh',
                        overflowY: 'auto',
                    }}>
                        <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>
                            Edit Level Meter
                        </h4>

                        <div style={{
                            display: 'flex',
                            gap: '30px',
                            marginBottom: '20px'
                        }}>
                            <div style={{
                                flex: '1',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '20px'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Level Meter Name
                                    </label>
                                    <input
                                        type="text"
                                        name="level_meter_name"
                                        value={currentMeter.level_meter_name}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Level Meter ID
                                    </label>
                                    <input
                                        type="text"
                                        name="level_meter_id"
                                        value={currentMeter.level_meter_id}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Serial Number
                                    </label>
                                    <input
                                        type="text"
                                        name="serial_number"
                                        value={currentMeter.serial_number}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>
                            </div>

                            <div style={{
                                flex: '1',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '20px'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Model
                                    </label>
                                    <input
                                        type="text"
                                        name="model"
                                        value={currentMeter.model}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Location
                                    </label>
                                    <input
                                        type="text"
                                        name="location"
                                        value={currentMeter.location}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#555'
                                    }}>
                                        Installation Date
                                    </label>
                                    <input
                                        type="date"
                                        name="installation_date"
                                        value={currentMeter.installation_date}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', width: '40%', marginLeft: '270px' }}>
                            <button
                                onClick={handleEditMeter}
                                style={{
                                    backgroundColor: '#4CAF50',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 15px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    flex: '1',
                                    marginRight: '10px',
                                }}
                            >
                                Save Changes
                            </button>
                            <button
                                onClick={() => {
                                    setShowEditModal(false);
                                    resetForm();
                                }}
                                style={{
                                    backgroundColor: '#f44336',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 15px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    flex: '1',
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showDeleteModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '8px',
                        width: '400px',
                        maxWidth: '90%',
                    }}>
                        <h2 style={{ marginBottom: '20px' }}>Confirm Delete</h2>
                        <p>Are you sure you want to delete the selected level meter(s)?</p>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                            <button
                                onClick={() => setShowDeleteModal(false)}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#cccccc',
                                    color: 'black',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDeleteMeter}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#f44336',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                }}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LevelMeter;